// extracted by mini-css-extract-plugin
export default {"croppingHint":"XQ7dGozCywOi3X5hiN6W"};